export const TEST_ID = 'detailsViewCardApplicationListItem';
